export default __webpack_public_path__ + "static/media/visa.244a66e3.svg";